module.exports = __webpack_public_path__ + "static/media/yours.d5fafc3e.svg";